import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

export const createPayPeriod = async (data) => {
  const res = await axiosInstance.post("/api/payroll-portal/pay-period", data);
  return res.data;
};

export const getAllPayPeriods = async () => {
  const res = await axiosInstance.get("/api/payroll-portal/pay-period");
  return res.data;
};

export const updatePayPeriod = async (id, data) => {
  const res = await axiosInstance.put(`/api/payroll-portal/pay-period/${id}`, data);
  return res.data;
};
